module.exports = __webpack_public_path__ + "static/media/logo_covid.6d067900.webp";